<template>
    <section class="recommended" v-if="originItems.length">
        <h2 class="main-ttl">Ми рекомендуємо</h2>

        <ul class="recommended-nav">
            <li :class=" !catFilterProp.length ? 'active' : '' ">
                <a href="" class="recommended-nav__item" @click.prevent="showAll" data-type="all">Всі пропозиції</a>
            </li>
            <li v-for="(item, index) in categories"
                :key="item.id"
                v-show="showCategory(index)"
                :class="catFilterProp.includes(item.id) ? 'active' : '' "
                >
                    <a href="javascript:void(0)"
                       :id="item.id"
                       :class="['recommended-nav__item', 'recommended-id-'+item.id ]"
                       @click.prevent="setCategoryFilter(item.id)">{{item.name}}</a>
            </li>
            <li>
                <a href="" class="recommended-nav__item f" @click.prevent="showMore" v-show="showMoreBtn">Більше …</a>
            </li>
        </ul>
        <!-- recommended-nav -->
        <div class="row recommended-block">
            <div class="col-sm-6 col-md-4 col-xl-3" v-for="(item, index) in printSpo" :key="index">
                <a :href="item.url"  target="_blank" class="recommended-item">
                    <div class="recommended-item__img bg-img bg-black-gradient"
                         :style="'background-image:  url('+item.image+')'">
                        <img :src="item.image" alt="">
                        <div class="recommended-item__detail">
                            <p><span v-if="item.stars">{{item.stars}}*</span> {{item.duration}}</p>
                            <i :class="item.icon_code"><span class="path1"></span><span class="path2"></span></i>
                        </div>
                        <div :class="['recommended-item__spo', 'recommended-item__spo--'+item.icon_position ]">
                            <img :src="item.icon" alt="">
<!--                            <a href="" id="2" class="recommended-nav__item recommended-id-2">Автобусні тури</a>-->
                        </div>
                    </div>
                    <div class="descr">
                        <p class="ttl">{{item.title}}</p>
                        <div class="descr-info">
                            <p class="descr-bottom__txt">{{item.fromDirection}}</p>
                            <p class="descr-cost">від
                                <span>{{item.price}} {{item.currency}}</span>
                            </p>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <div v-if="!printSpo.length" class="text-center"><h3>По вашому фільтру нічого не знайдено</h3></div>

       <!-- <pagination :pagination="pagination" :callback="loadData" :options="paginationOptions"
                    class="text-center"></pagination>-->

        <paginate v-if="!currentItems.length == 0" class="text-center"
            v-model="page"
            :pageCount="pageCount"
            :clickHandler="loadData"
            :page-range="3"
            :margin-pages="2"
            :prevText="'Prev'"
            :nextText="'Next'"
            :container-class="'pagination'"
            >
        </paginate>
    </section>
    <!-- recommended -->
</template>
<script>
    import pagination from "vue-bootstrap-pagination";
    import Paginate from "vuejs-paginate";

    export default {
        props: ['country'],
        components: {
            pagination,
            Paginate
        },
        data() {
            return {
                categories: [],
                showElCategory: 4,
                showMoreBtn: true,
                catFilterProp: [],
                currentItems: [],
                originItems: [],
                page: 1,
                pageCount: 0,
                pagination: {
                    total: 0,
                    per_page: 8,
                    current_page: 1,
                    last_page: 0,
                    from: 0,
                    to: 8
                },
                paginationOptions: {
                    offset: 2,
                    previousText: "Prev",
                    nextText: "Next",
                    alwaysShowPrevNext: true
                }
            };
        },
        computed: {
            printSpo() {
                this.pagination.last_page = Math.ceil(this.currentItems.length / this.pagination.per_page);
                this.pageCount = this.pagination.last_page;
                let currentItems = this.currentItems;

                return currentItems.slice(this.pagination.from, this.pagination.to);
            }
        },
        methods: {
            showCategory(index) {
                return index <= this.showElCategory;
            },
            showMore() {
                this.showMoreBtn = false;
                this.showElCategory = this.categories.length;
            },
            setCategoryFilter(id) {
                this.catFilterProp.splice(index, this.catFilterProp.length);
                let index = this.catFilterProp.indexOf(id);
                (index >= 0) ? this.catFilterProp.splice(index, 1) : this.catFilterProp.push(id);

                let element = document.getElementById(id);
                let cls = "recommended-id-"+id;
                if (element.classList.contains(cls)){
                    element.classList.remove(cls);
                }else{
                    element.classList.add(cls);
                }

                this.performCategoryFilter();
            },
            showAll() {
                this.catFilterProp = [];

                this.performCategoryFilter();
            },
            performCategoryFilter() {
                this.pagination.current_page = 1;
                this.pagination.to = this.pagination.per_page;
                this.pagination.from = this.pagination.to - this.pagination.per_page;

                var _this = this;
                if (_this.catFilterProp.length > 0) {
                    let tmpList = [];

                    this.catFilterProp.forEach(cat => {
                        let tmpItem = _this.originItems.filter(function (item) {
                            // if (item.categories) {
                                return item.categories.includes(cat);
                            // } else {
                            //     return false;
                            // }
                        });

                        tmpList = tmpList.concat(tmpItem.filter(elem => !tmpList.includes(elem)));
                        // tmpList = tmpList.concat(tmpItem);
                    });

                    return (_this.currentItems = tmpList);
                } else {
                    return (_this.currentItems = _this.originItems);
                }
            },
            loadData(e) {
                this.pagination.to = this.page * this.pagination.per_page;
                this.pagination.from = this.pagination.to - this.pagination.per_page;
            }
        },
        mounted() {

            let catCount = 0;
            if (!this.country) {
                axios.post("/categories").then(response => {
                    this.categories = response.data;
                    catCount = this.categories.length;
                });
                this.pagination.per_page = 8;
                axios.post("/spo").then(response => {
                    const itemsArray = Object.values(response.data);
                    this.pagination.last_page = Math.ceil(itemsArray.length / this.pagination.per_page);

                    this.currentItems = itemsArray;
                    this.originItems = itemsArray;
                });
            } else {
                axios.post("/spo-country", {countryId: this.country}).then(response => {

                    this.categories = response.data.categories;
                    const itemsArray = Object.values(response.data.spo);
                    this.pagination.last_page = Math.ceil(itemsArray.length / this.pagination.per_page);
                    this.currentItems = itemsArray;
                    this.originItems = itemsArray;
                    catCount = this.categories.length;
                    this.showMoreBtn = this.categories.length > 5;
                });
                this.pagination.per_page = 4;
            }
            this.pagination.to = this.pagination.per_page;
        },

	    // updated: function () {
		 //    this.$nextTick(function () {
			//     console.warn({nav: this.categories});
        //
			//     console.warn({currentItems: this.currentItems});
			//     console.warn({printSpo: this.printSpo});
        //
			//     console.warn({originItems: this.originItems});
        //
			//     console.warn({catFilterProp: this.catFilterProp});
        //
			//     console.warn({showElCategory: this.showElCategory});
        //
			//     console.log("----------------------------------");
		 //    })
	    // }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Spo.vue